import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, normalizeClass as _normalizeClass, withCtx as _withCtx, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "gallery-container" }
const _hoisted_2 = {
  key: 0,
  class: "clue"
}
const _hoisted_3 = { class: "clue-wrapper" }
const _hoisted_4 = {
  key: 1,
  class: "not-found"
}
const _hoisted_5 = { class: "not-found-wrapper" }
const _hoisted_6 = {
  ref: "galleryRef",
  class: "gallery-wrapper"
}
const _hoisted_7 = { class: "search" }
const _hoisted_8 = { class: "actions-mode" }
const _hoisted_9 = {
  key: 0,
  class: "choose-checkbox"
}
const _hoisted_10 = {
  key: 1,
  class: "choose-checkbox"
}
const _hoisted_11 = {
  key: 2,
  class: "filter-fill"
}
const _hoisted_12 = { class: "icon-list-ol" }
const _hoisted_13 = { class: "icon-ellipsis-h" }
const _hoisted_14 = {
  key: 0,
  class: "icon"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!
  const _component_AppLoader = _resolveComponent("AppLoader")!
  const _component_app_input = _resolveComponent("app-input")!
  const _component_AppCheckbox = _resolveComponent("AppCheckbox")!
  const _component_app_button = _resolveComponent("app-button")!
  const _component_app_image_card = _resolveComponent("app-image-card")!
  const _component_app_virtual_scroll_grid = _resolveComponent("app-virtual-scroll-grid")!
  const _component_app_popover_item = _resolveComponent("app-popover-item")!
  const _component_app_popover_wrapper = _resolveComponent("app-popover-wrapper")!
  const _component_app_popover = _resolveComponent("app-popover")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.isClueSection)
      ? (_openBlock(), _createElementBlock("section", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createVNode(_component_font_awesome_icon, {
              size: "xl",
              icon: ['fas', 'exclamation-triangle']
            }),
            _createTextVNode(" " + _toDisplayString(_ctx.t('galleryEmpty')) + " ", 1),
            _createVNode(_component_font_awesome_icon, {
              size: "xl",
              icon: ['fas', 'images'],
              onClick: _ctx.openCollageModal
            }, null, 8, ["onClick"])
          ])
        ]))
      : _createCommentVNode("", true),
    (_ctx.isNotFoundSection)
      ? (_openBlock(), _createElementBlock("section", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, _toDisplayString(_ctx.t('noResults')), 1)
        ]))
      : _createCommentVNode("", true),
    (_ctx.isLoading)
      ? (_openBlock(), _createBlock(_component_AppLoader, { key: 2 }))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_6, [
      _createElementVNode("section", {
        class: _normalizeClass(["gallery-helper", { hidden: _ctx.isHidden }])
      }, [
        _createElementVNode("div", _hoisted_7, [
          _createVNode(_component_app_input, {
            modelValue: _ctx.search,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.search) = $event)),
            type: "search",
            placeholder: "search",
            icon: ['fas', 'search'],
            "is-label": false,
            "submit-on-search": true,
            onSearch: _ctx.runSearch
          }, null, 8, ["modelValue", "onSearch"])
        ]),
        _createElementVNode("section", _hoisted_8, [
          (!_ctx.isMobile)
            ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                _createVNode(_component_AppCheckbox, {
                  modelValue: _ctx.isSelectedMode,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.isSelectedMode) = $event)),
                  label: "choose"
                }, null, 8, ["modelValue"])
              ]))
            : _createCommentVNode("", true),
          (_ctx.isSelectedMode && !_ctx.isMobile)
            ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                _createVNode(_component_AppCheckbox, {
                  modelValue: _ctx.chooseAll,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.chooseAll) = $event)),
                  label: "chooseAll"
                }, null, 8, ["modelValue"])
              ]))
            : _createCommentVNode("", true),
          _createVNode(_component_app_button, {
            severity: "secondary",
            raised: "",
            icon: ['fas', 'filter'],
            onClick: _ctx.openFilterModal
          }, null, 8, ["onClick"]),
          (!_ctx.isFilterEmpty)
            ? (_openBlock(), _createElementBlock("div", _hoisted_11))
            : _createCommentVNode("", true)
        ])
      ], 2),
      _createElementVNode("section", {
        ref: "imagesContainer",
        class: _normalizeClass(["images", { hidden: _ctx.isHidden }])
      }, [
        _createVNode(_component_app_virtual_scroll_grid, {
          items: _ctx.images,
          "item-key": (item) => item.id,
          "min-column-width": _ctx.isMobile ? 100 : 250,
          "row-height": _ctx.isMobile ? 150 : 300,
          height: _ctx.heightImagesContainer,
          onScroll: _ctx.onScroll
        }, {
          default: _withCtx(({ item, index }) => [
            _createVNode(_component_app_image_card, {
              src: item.src,
              image: item,
              onClick: ($event: any) => (_ctx.openCardModal(index))
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.t('photo')) + " " + _toDisplayString(_ctx.getCurrentIndex(item) + 1), 1)
              ]),
              _: 2
            }, 1032, ["src", "image", "onClick"])
          ]),
          _: 1
        }, 8, ["items", "item-key", "min-column-width", "row-height", "height", "onScroll"])
      ], 2),
      _createElementVNode("footer", {
        class: _normalizeClass(["footer", { hidden: _ctx.isHidden }])
      }, [
        _createElementVNode("div", _hoisted_12, [
          _createVNode(_component_font_awesome_icon, {
            size: "lg",
            icon: ['fas', 'list-ol']
          }),
          _createElementVNode("span", null, _toDisplayString(_ctx.totalImages), 1)
        ]),
        _createElementVNode("div", _hoisted_13, [
          (_ctx.isMobile)
            ? (_openBlock(), _createBlock(_component_font_awesome_icon, {
                key: 0,
                icon: ['fas', 'ellipsis-h'],
                size: "lg",
                onClick: _withModifiers(_ctx.openPopover, ["stop"])
              }, null, 8, ["onClick"]))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("section", {
          class: _normalizeClass(["selected-section", { mobile: _ctx.isMobile }])
        }, [
          (_ctx.isSelectedMode && _ctx.selected.length)
            ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                _createVNode(_component_font_awesome_icon, {
                  size: "lg",
                  icon: ['fas', 'images'],
                  onClick: _ctx.openCollageModal
                }, null, 8, ["onClick"]),
                _createTextVNode(" " + _toDisplayString(_ctx.selected.length), 1)
              ]))
            : _createCommentVNode("", true),
          (_ctx.isSelectedMode && _ctx.selected.length)
            ? (_openBlock(), _createElementBlock("div", {
                key: 1,
                class: "icon",
                onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.clearSelected && _ctx.clearSelected(...args)))
              }, [
                _createVNode(_component_font_awesome_icon, {
                  size: "lg",
                  icon: ['fas', 'broom']
                })
              ]))
            : _createCommentVNode("", true),
          (_ctx.isSelectedMode && _ctx.selected.length)
            ? (_openBlock(), _createElementBlock("div", {
                key: 2,
                class: "icon",
                onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.openDeleteModal && _ctx.openDeleteModal(...args)))
              }, [
                _createVNode(_component_font_awesome_icon, {
                  size: "lg",
                  icon: ['fas', 'fa-trash']
                })
              ]))
            : _createCommentVNode("", true)
        ], 2)
      ], 2),
      _createVNode(_component_app_popover, {
        visible: _ctx.visiblePopover,
        "onUpdate:visible": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.visiblePopover) = $event))
      }, {
        default: _withCtx(() => [
          _createVNode(_component_app_popover_wrapper, null, {
            default: _withCtx(() => [
              _createVNode(_component_app_popover_item, null, {
                default: _withCtx(() => [
                  _createVNode(_component_AppCheckbox, {
                    modelValue: _ctx.isSelectedMode,
                    "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.isSelectedMode) = $event))
                  }, null, 8, ["modelValue"]),
                  _createElementVNode("span", null, _toDisplayString(_ctx.t('choose')), 1)
                ]),
                _: 1
              }),
              (_ctx.isSelectedMode)
                ? (_openBlock(), _createBlock(_component_app_popover_item, { key: 0 }, {
                    default: _withCtx(() => [
                      _createVNode(_component_AppCheckbox, {
                        modelValue: _ctx.chooseAll,
                        "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.chooseAll) = $event))
                      }, null, 8, ["modelValue"]),
                      _createElementVNode("span", null, _toDisplayString(_ctx.t('chooseAll')), 1)
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true)
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["visible"])
    ], 512)
  ]))
}